import { combineReducers } from 'redux';
import { skillsReducer } from './skillsReducer';
import {scorecardsReducer} from './scorecardsReducer';


const settingsReducer = combineReducers({
  skills: skillsReducer,
  scorecards: scorecardsReducer,
});

export { settingsReducer };